<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">
		<spinner v-if="loading">
		</spinner>

		<template v-else>

			<div class="app-container">
				<bar>
				</bar>
				<h1>{{ $t('Edit') }} {{ $t('e-mail') }}<span v-if="emailaddress.dirty">*</span>
				</h1>
				<message
						v-if="emailaddress.dirty"
						:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
						border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
				</message>
				<div class="datedata">
					<p class="small">{{ $t('Created') }}: {{ millis_to_time(emailaddress.date_created)
						}}</p>
					<p class="small">{{ $t('Last_modified')
						}}: {{ millis_to_time(emailaddress.date_modified) }}</p>
				</div>
				<div>
					<form class="bt-form">
						<div class="section-container">
							<h3>{{ $t('E-mail_address') }}</h3>

							<div class="field-container">
								<div class="field__group">
									<label class="field__group__label">{{ $t('E-mail_address') }}</label>
									<input class="field__group__input"
										   type="email"
										   step="1"
										   spellcheck="false"
										   v-model="emailaddress.address"
										   @input="set_emailaddress_address">
								</div>
							</div>

						</div>
						<div class="section-container">
							<h3>{{ $t('Description') }}</h3>

							<div class="field-container">
								<div class="field__group">
									<label class="field__group__label">{{ $t('Description') }}</label>
									<input class="field__group__input"
										   type="text"
										   spellcheck="false"
										   v-model="emailaddress.description"
										   @input="set_emailaddress_description">
								</div>
							</div>

						</div>

						<div>
							<hr>
						</div>

						<div>
							<div @click.prevent="onGoBack" style="width: fit-content; margin-left: auto">
								<icon-button icon="chevron-left" :text="goback_button_text"
											 icon_color="black"
											 text_color="black" border_color="lightgray"></icon-button>
							</div>
						</div>
						<div>
							<div @click.prevent="onSaveCurrentEmailAddress({goback: true})"
								 style="width: fit-content; margin-left: auto">
								<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
											 text_color="white" border_color="#006bc5"
											 background_color="#0087F8"></icon-button>
							</div>
						</div>
						<message
								v-if="emailaddress.dirty"
								:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
								border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
						</message>
					</form>
				</div>
				<!--<bar>
				</bar>
-->
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    export default {
        name: 'emailaddress-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            loading: true,
            error: null,
            success_message: null,
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_back'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
        }),

        created () {
                this.loading = false
        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner
        },

        computed: {
            ...mapGetters([
                'theme',
                'currentLocale',
                'emailaddress',
            ])
        },

        methods: {
            ...mapActions(
                [
                    'SET_EMAILADDRESS_ADDRESS',
                    'SET_EMAILADDRESS_DESCRIPTION',
                    'UPDATE_EMAILADDRESS'
                ]),

            set_emailaddress_address: _.debounce(function (e) {
                this.SET_EMAILADDRESS_ADDRESS(e.target.value)
            }, 1000),
            set_emailaddress_description: _.debounce(function (e) {
                this.SET_EMAILADDRESS_DESCRIPTION(e.target.value)
            }, 1000),
            onSaveCurrentEmailAddress: function () {
                this.UPDATE_EMAILADDRESS({
                    object: this.emailaddress,
                    path: this.emailaddress.path + '/' + this.emailaddress.id
                }).then((res) => {
                    router.go(-1)
                })
            },
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            }
        },
        head: {
            title: {
                inner: 'Edit e-mail realestate'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// EmailAddressEditor.vue?3a57161e